import React from 'react';
import Link from 'next/link';
import { Box, Typography, IconButton, Chip } from '@mui/material';
import { Text, CopyIcon, CallIcon } from 'components/common/ui';
import styles from './servicePointSidebar.styles';

export const ContactList = ({ label, contacts, loading, type = 'person' }) => {
  const handleCopyToClipboard = (value) => {
    navigator.clipboard.writeText(value);
  };

  const renderContactItem = (contact, index) => {
    if (type === 'person') {
      if (!contact.fullName && !contact.email) return null;
      return (
        <Box key={contact.id || contact.email || index} sx={styles.contactItem}>
          {contact.isPrimary && (
            <Chip label="Primary" size="small" sx={styles.primaryChip} />
          )}
          <Text loading={loading} sx={styles.contactText}>
            {contact.fullName || contact.email || '-'}
          </Text>
        </Box>
      );
    }

    if (type === 'phone') {
      const phoneNumber = contact?.phoneNumber?.phoneNumber;
      if (!phoneNumber) return null;
      return (
        <Box
          key={`phone-${contact.id || contact.email || phoneNumber}`}
          sx={{ mb: 0.5 }}
        >
          <Box sx={styles.contactItem}>
            {contact.isPrimary && (
              <Chip label="Primary" size="small" sx={styles.primaryChip} />
            )}
            <Text loading={loading} sx={styles.contactPhoneText}>
              {phoneNumber}
            </Text>
            <IconButton
              disabled={loading}
              onClick={() => handleCopyToClipboard(phoneNumber)}
              sx={styles.callButton}
            >
              <Link
                href={`tel:${phoneNumber}`}
                passHref
                style={{ display: 'flex' }}
              >
                <CallIcon />
              </Link>
            </IconButton>
          </Box>
        </Box>
      );
    }

    if (type === 'email') {
      const email = contact?.email;
      if (!email) return null;
      return (
        <Box key={`email-${contact.id || email}`} sx={{ mb: 0.5 }}>
          <Box sx={styles.contactItem}>
            {contact.isPrimary && (
              <Chip label="Primary" size="small" sx={styles.primaryChip} />
            )}
            <Text loading={loading} sx={styles.contactEmailText}>
              {email}
            </Text>
            <IconButton
              disabled={loading}
              onClick={() => handleCopyToClipboard(email)}
              sx={styles.copyButton}
            >
              <CopyIcon />
            </IconButton>
          </Box>
        </Box>
      );
    }

    return null;
  };

  const filteredContacts = contacts.filter((contact) => {
    if (type === 'person') return contact.fullName || contact.email;
    if (type === 'phone') return contact?.phoneNumber?.phoneNumber;
    if (type === 'email') return contact?.email;
    return false;
  });

  if (filteredContacts.length === 0) return null;

  return (
    <Box>
      <Typography sx={styles.fieldLabel}>{label}</Typography>
      {contacts.map((contact, index) => renderContactItem(contact, index))}
    </Box>
  );
};
